import { Button } from "reactstrap";
import httpService from "../../../../services/http.service";
import SuccessMessage from "../../../common/successMsg";
import Loader from "../../../common/loader";
import { useEffect, useState } from "react";

const Email = ({reloadsub}) => {
    const customerID = localStorage.getItem("customerId");
    const [loderOn, setLoderOn] = useState(false)
    const sentEmailRequest = async () => {
        await sentUsersNASRequest()
        // alert("soon our sel exutive contact you")
    }


    useEffect(()=>{
        // reloadsub()
    },[])


    async function sentUsersNASRequest() {
        try {
            setLoderOn(true)
            let data = {
                name: customerID
            }
            const res = await httpService.CreateUpdate('nas/USER_NAS_REQUEST', data);
            console.log(res.data, "USER_NAS_DETAIL");
            if (res?.data) {
                SuccessMessage("Request has been send Our sales executive Contact you soon.")
                setLoderOn(false)
            }
        } catch (err) {
            console.log({ err });
            setLoderOn(false)

        }
    }
    
    return <div>
        {/* <form> //jdbjs */}
        {loderOn && <Loader msg="Sending your request..."/> }
       

            <div className="form-boxdiv2">
                <div className="form-boxtopline5">
                    MANAGE YOUR RCC Cloud DRIVE DATA
                    {/* <button className="btn btn-primary" onClick={() => { history.push("/clouddashboard") }}>Go Back</button> */}
                </div>
                <div className="cloud-portal">
                    <div className="main-content">
                        <div className="files-section">
                            <div className="file-controls " style={{ textAlign: "center", padding: "100px" }}>
                                <div style={{ textAlign: "center", padding: "10px" }}>
                                    <p>
                                        Would  you like to request a license for establishing a
                                        connection with our RCC Cloud system.

                                    </p>
                                </div>
                                <div style={{ textAlign: "center" }}>
                                    <Button color="primary" onClick={sentEmailRequest}>Request</Button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
}

export default Email;